export default "__VITE_ASSET__DOWF7Ndy__"